/*
 * @Author: summer
 * @Date: 2019-08-12 09:48:09
 * @LastEditTime: 2019-08-12 09:53:35
 * @LastEditors: Do not edit
 */
/* eslint-disable no-console */
import React, { Component } from 'react';

const urlMap = {};

export default class ComponentLoader extends Component {
    constructor(props) {
        super(props);
        this.state = { component: null };
        this.path = props._path;
    }

    componentDidMount() {
        this.createScript(this.path);
    }

    componentWillUnmount() {
        // 移除事件监听
        if (this.script) {
            this.script.removeEventListener('load', this.a);
            this.script.removeEventListener('error', this.b);
            delete this.script;
        }
    }

	createScript = path => {
	    if (path) {
	        let urlInfo = urlMap[path];
	        if (urlInfo) {
	            switch (urlInfo.status) {
	                case 'pending':
	                    urlInfo.script.addEventListener('load', this.handleLoad);
	            		urlInfo.script.addEventListener('error', this.handleError);
	                    break;
	                case 'resolve':
	                    this.handleLoad();
	                    break;
	                case 'reject':
	                    this.handleError();
	                    break;
	            }
	        } else {
	            let script = document.createElement('script');
	            script.src = path;
	            script.type = 'text/javascript';
	            document.body.appendChild(script);
	            this.script = script;
	            urlMap[path] = {
	                script,
	                status: 'pending',
	            }
	            this.createScript(path);
	        }
	    }
	};

	handleError = () => {
	    this.setState({ component: null });
	    urlMap[this.path].status = 'reject';
	}

	handleLoad = () => {
	    let key = /(?:\.\.\/)*(.*)\.js/g.exec(this.path);
	    key = key && key[1];
	    try {
	        this.setState({ component: window[key].default });
	        urlMap[this.path].status = 'resolve';
	    } catch (e) {
	        this.setState({ component: null });
	        urlMap[this.path].status = 'reject';
	        console.error(e.message);
	    }
	};

	render() {
	    let App = this.state.component;
	    return typeof App === 'function' && <App {...this.props} />;
	}
}
